<template>
  <div class="outerBox">
    <div class="loading" v-if="loading" v-loading="loading"></div>
    <div id="graphAreaPickup" v-if="!loading"></div>
    <div class="empty" v-if="!hasData">
      <empty></empty>
    </div>
    <!-- <div id="btnsDiv">
      <el-button :disabled="edgeBtnFlag" @click="showEdges()">显示边</el-button>
      <el-button :disabled="nodeBtnFlag" @click="showNodes()">显示点</el-button>
    </div> -->
    <div id="nodesBox">
      <div id="nodesBtn">x</div>
      <div id="nodesBoxInfo"></div>
    </div>
    <div id="edgesBox">
      <div id="closeBtn">x</div>
      <div id="edgesBoxInfo"></div>
    </div>
    <!-- <div id="nodePath">
      <el-tabs v-model="tabDataName">
        <el-tab-pane label="查找关系" name="Relationship">
          <el-input class="nodePathItem" v-model="getTwoNodePathParams.srcId"></el-input>
          <el-input class="nodePathItem" v-model="getTwoNodePathParams.tarId"></el-input>
          <el-input-number
            class="nodePathItem"
            controls-position="right"
            v-model="getTwoNodePathParams.level"
            :min="0"
            :max="10"
          ></el-input-number>
        </el-tab-pane>
        <el-tab-pane label="查找点" name="point">
          <el-select class="nodePathItem" v-model="searchNodeToGraphDataParams.nodeName">
            <el-option v-for="item in tagEdgeList" :value="item.value" :key="item.value">{{
              item.label
            }}</el-option>
          </el-select>
          <el-input class="nodePathItem" v-model="searchNodeToGraphDataParams.label"></el-input>
        </el-tab-pane>
      </el-tabs>
      <div class="nodePathItem">
        <el-button type="primary" @click="findPath">查找</el-button>
      </div>
    </div> -->
    <!-- <el-dialog v-model="show">
      <div>
        <div></div>
        <div style="padding:10px">
          <div v-for="(value, key, index) in checkLists" :key="index">
            <div>{{ key }}</div>
            <el-radio-group v-model="value.model">
              <el-radio v-for="(item, index) in value.arr" :key="index" :label="item.label">
                <span>{{ item.value }}</span>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">
          确定
        </el-button>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import axios from 'axios';
import $ from '../../../public/cdn/jquery-3.2.1/jquery-3.2.1.min.js';
import igraph from '../../../public/cdn/interactive-graph-0.1.0/interactive-graph.min.js';
import init from '@/mixins/chart';
export default {
  name: 'igraph-pickup',
  inject: ['container'],
  mixins: [init],
  props: {
    option: Object,
    component: Object
  },
  data() {
    return {
      // 请求方法
      methodPost: 'post',
      methodGet: 'get',
      // 图结构
      graphDataUrl: '/api/rest_j/v1/nebulaService/manage/graphData',
      graphDataParams: {
        spaceName: 'test2',
        script: "MATCH (n:DP) WHERE n.label IN ['11.53.0.6:80'] RETURN n;"
      },
      // 获取一个节点的其他节点
      getNodeRelationByIdUrl: '/api/rest_j/v1/nebulaService/manage/getNodeRelationById',
      getNodeRelationByIdParams: {
        spaceName: 'test2',
        nodeId: '',
        relationShip: '' //可选
      },
      // 查找关系
      getTwoNodePathUrl: '/api/rest_j/v1/nebulaService/manage/getTwoNodePath',
      getTwoNodePathParams: {
        spaceName: 'test2', //命名空间
        srcId: '01', //开始节点
        tarId: '1cc4207a6b46eb97e4c3d0edc3e4ae5c', //结束节点
        level: 3, //最多查询多少层
        relationShip: '*' // 目标路径，例如：invest1,invest2 默认是*
      },
      // 查找点
      searchNodeToGraphDataUrl: '/api/rest_j/v1/nebulaService/manage/searchNodeToGraphData',
      searchNodeToGraphDataParams: {
        spaceName: 'test2',
        label: '',
        id: '',
        nodeName: ''
      },
      // 获取点边列表
      getTagEdgeInfoUrl: '/api/rest_j/v1/nebulaService/manage/getTagEdgeInfo',
      getTagEdgeInfoParams: {
        spaceName: 'test2',
        name: '',
        option: '' // nodes edges
      },
      // 获取节点和边的列表
      getTagEdgeListUrl: '/api/rest_j/v1/nebulaService/manage/getTagEdgeList',
      getTagEdgeListParams: {
        spaceName: 'test2',
        option: 'nodes' // nodes edges
      },
      // 判断点击的是边还是点
      edgeNodeFlag: false,
      edgeBtnFlag: true,
      nodeBtnFlag: true,
      // 弹窗展示
      show: false,
      // 弹窗数据
      checkList: [],
      checkLists: {},
      // 弹窗选中数据
      socialArr: {
        nodeSocial: '',
        edgeSocial: ''
      },
      // tab
      tabDataName: 'Relationship',
      tagEdgeList: [],
      // loading
      loading: false
    };
  },
  computed: {
    hasData() {
      return this.dataChart?.data?.nodes.length > 0;
    },
    dataObj() {
      return this.dataChart;
    },
    togglePhysics() {
      return this.option.togglePhysics;
    },
    toggleShadow() {
      return this.option.toggleShadow;
    },
    toggleNavigationButtons() {
      return this.option.toggleNavigationButtons;
    },
    toggleSearchBar() {
      return this.option.toggleSearchBar;
    },
    toggleDraggable() {
      return this.option.toggleDraggable;
    },
    background() {
      return this.option.background;
    },
    edgeColor() {
      return this.option.edgeColor;
    },
    highlight() {
      return this.option.highlight;
    },
    hover() {
      return this.option.hover;
    },
    opacity() {
      return this.option.opacity;
    },
    fontColor() {
      return this.option.fontColor;
    },
    size() {
      return this.option.size;
    },
    hoverWidth() {
      return this.option.hoverWidth;
    },
    selectionWidth() {
      return this.option.selectionWidth;
    },
    width() {
      return this.option.width;
    },
    nodeLabelColor() {
      return this.option.nodeLabelColor;
    },
    nodeSize() {
      return this.option.nodeSize;
    },
    nodeColor() {
      return this.option.nodeColor;
    }
  },
  watch: {
    dataObj() {
      this.getGraphData();
    },
    togglePhysics() {
      this.loadGraph();
    },
    toggleShadow() {
      this.loadGraph();
    },
    toggleNavigationButtons() {
      this.loadGraph();
    },
    toggleSearchBar() {
      this.loadGraph();
    },
    toggleDraggable() {
      this.loadGraph();
    },
    background() {
      this.loadGraph();
    },
    edgeColor() {
      this.loadGraph();
    },
    highlight() {
      this.loadGraph();
    },
    hover() {
      this.loadGraph();
    },
    opacity() {
      this.loadGraph();
    },
    fontColor() {
      this.loadGraph();
    },
    size() {
      this.loadGraph();
    },
    hoverWidth() {
      this.loadGraph();
    },
    selectionWidth() {
      this.loadGraph();
    },
    width() {
      this.loadGraph();
    },
    nodeLabelColor() {
      this.loadGraph();
    },
    nodeSize() {
      this.loadGraph();
    },
    nodeColor() {
      this.loadGraph();
    }
  },
  created() {},
  mounted() {
    if (this.$route.name === 'view') {
      setTimeout(() => {
        const scale = document.getElementById('container').style.transform;
        const scaleArr = scale.substring(scale.indexOf('(') + 1, scale.indexOf(')')).split(',');
        if (scaleArr.length < 2) {
          document.getElementById('graphAreaPickup').style.transform =
            'scale(' + this.decimalsToFractional(Number(scaleArr[0])) + ')';
          document.getElementById('graphAreaPickup').style.width = scaleArr[0] * 100 + '%';
          document.getElementById('graphAreaPickup').style.height = scaleArr[0] * 100 + '%';
        } else {
          document.getElementById('graphAreaPickup').style.transform =
            'scale(' +
            this.decimalsToFractional(Number(scaleArr[1])) +
            ', ' +
            this.decimalsToFractional(Number(scaleArr[1])) +
            ')';
          document.getElementById('graphAreaPickup').style.width = scaleArr[0] * 100 + '%';
          document.getElementById('graphAreaPickup').style.height = scaleArr[1] * 100 + '%';
        }
      }, 10);
    }
  },
  methods: {
    // 获取图数据（刚进来）
    async getGraphData() {
      this.loading = true;
      this.dataObj = this.backUpLabel(this.dataObj);
      // const { data } = await this.axiosFn(this.methodPost, this.graphDataUrl, this.graphDataParams);
      // this.dataObj = this.backUpLabel(data.data);
      await this.loadGraph();
    },
    // 加载图
    async loadGraph() {
      igraph.i18n.setLanguage('chs');
      const app = new igraph.GraphNavigator(document.getElementById('graphAreaPickup'), 'LIGHT');
      app.loadGson(
        JSON.stringify(this.dataObj),
        {
          onGetNodeDescription: () => {}
        },
        () => {}
      );
      this.loading = false;
      // 不展示默认info框
      app.toggleInfoBox(false);
      // 不展示默认边点数
      app.toggleStatusBar(false);
      // 默认显示label
      app.toggleShowEdgeLabelAlways(true);
      app.togglePhysics(this.togglePhysics);
      app.toggleShadow(this.toggleShadow);
      app.toggleNavigationButtons(this.toggleNavigationButtons);
      app.toggleSearchBar(this.toggleSearchBar);
      app.toggleDraggable(this.toggleDraggable);
      // 改变边样式
      app.updateNetworkOptions(t => {
        t.edges.color.color = this.edgeColor;
        t.edges.color.highlight = this.highlight;
        t.edges.color.hover = this.hover;
        t.edges.color.opacity = 1;
        t.edges.font.color = this.fontColor;
        t.edges.font.size = this.size;
        t.edges.hoverWidth = this.hoverWidth;
        t.edges.selectionWidth = this.selectionWidth;
        t.edges.width = this.width;

        t.nodes.font.size = this.nodeSize;
        t.nodes.font.color = this.nodeLabelColor;
        this.dataObj.data.nodes.map(o => {
          t.groups[o.categories[0]] = { color: this.nodeColor };
        });
      });
      $('#graphAreaPickup').css('background', this.background);
      // 单击事件
      app.on('NETWORK_CLICK', t => {
        if (t.nodes.length === 0) {
          // 点击的边
          let edge = t.mainFrame._network.body.data.edges._data[t.edges[0]];
          if (edge) {
            let edgeInfo = {};
            this.dataObj.data.edges.map(o => {
              if (o.id === edge.id) {
                edgeInfo = o;
              }
            });
            for (let key in edgeInfo) {
              if (!edge[key]) {
                edge[key] = edgeInfo[key];
              }
            }

            let str = '<p>';
            for (let key in edge) {
              if (key !== 'from' && key !== 'to' && key !== 'hidden' && key !== 'backUpLabel') {
                str += '<p>' + '<span>' + key + '</span>：<span>' + edge[key] + '</span>' + '</p>';
              }
            }
            str += '</p>';
            $('#edgesBoxInfo').html(str);
            $('#edgesBox').css('display', 'block');
            $('#closeBtn').click(() => {
              $('#edgesBox').css('display', 'none');
            });
          }
        } else {
          // 点击的点
          let node = t.mainFrame._network.body.data.nodes._data[t.nodes[0]];
          if (node) {
            let nodeInfo = {};
            this.dataObj.data.nodes.map(o => {
              if (o.id === node.id) {
                nodeInfo = o;
              }
            });
            for (let key in nodeInfo) {
              if (!node[key]) {
                node[key] = nodeInfo[key];
              }
            }

            this.progressClick({
              label: node.label,
              id: node.id,
              port: node.port,
              categories: node.categories
            });

            let description = '<p align=center>';
            for (let key in node) {
              if (key === 'categories') {
                description += '<p>' + '<span>' + key + '</span>：<span>';
                description += node[key].join(',');
                description += '</span>' + '</p>';
              } else if (
                key !== 'title' &&
                key !== 'hidden' &&
                key !== 'group' &&
                key !== 'backUpLabel' &&
                key !== 'x' &&
                key !== 'y'
              ) {
                description +=
                  '<p>' + '<span>' + key + '</span>：<span>' + node[key] + '</span>' + '</p>';
              }
            }
            description += '</p>';
            $('#nodesBoxInfo').html(description);
            $('#nodesBox').css('display', 'block');
            $('#nodesBtn').click(() => {
              $('#nodesBox').css('display', 'none');
            });
          }
        }
      });
      // 双击事件
      app.on('NETWORK_DBLCLICK', async () => {
        // if (t.nodes.length > 0) {
        //   // 点击的点
        //   this.getNodeRelationByIdParams.nodeId = t.nodes[0];
        //   this.loading = true;
        //   await this.axiosFn(
        //     this.methodPost,
        //     this.getNodeRelationByIdUrl,
        //     this.getNodeRelationByIdParams
        //   ).then(data => {
        //     for (let key in this.backUpLabel(data.data.data).data) {
        //       this.backUpLabel(data.data.data).data[key].map(o => {
        //         if (typeof o === 'string') {
        //           if (this.dataObj.data[key].indexOf(o) < 0) {
        //             this.dataObj.data[key].push(o);
        //           }
        //         } else if (typeof o === 'object') {
        //           this.dataObj.data[key].push(o);
        //         }
        //       });
        //     }
        //     this.nodeUpdataFn();
        //     this.edgeUpdataFn();
        //     this.loading = false;
        //   });
        // }
        // this.btnShowFn();
      });
      this.btnShowFn();
      return app;
    },
    // 节点更新
    async nodeUpdataFn() {
      this.dataObj.data.nodes.map(o => {
        let labelArr = [];
        for (let key in this.checkLists) {
          o.categories.map(p => {
            if (key === p && this.checkLists[key].model !== '') {
              if (this.checkLists[key].model === 'label') {
                labelArr.push(o['backUpLabel']);
              } else {
                labelArr.push(o[this.checkLists[key].model]);
              }
            }
          });
        }
        o.label = labelArr.length === 0 ? o.backUpLabel : labelArr.join('&');
      });
      await this.loadGraph().then(res => {
        res.updateNodes(this.dataObj.data.nodes);
      });
    },
    // 边更新
    async edgeUpdataFn() {
      this.dataObj.data.edges.map(o => {
        let labelArr = [];
        for (let key in this.checkLists) {
          if (key === o.edgeName && this.checkLists[key].model !== '') {
            if (this.checkLists[key].model === 'label') {
              labelArr.push(o['backUpLabel']);
            } else {
              labelArr.push(o[this.checkLists[key].model]);
            }
          }
        }
        o.label = labelArr.length === 0 ? o.backUpLabel : labelArr.join('&');
      });
      await this.loadGraph().then(res => {
        res.updateEdges(this.dataObj.data.nodes);
      });
    },
    // 增加备份label
    backUpLabel(data) {
      const newData = data;
      newData.data.nodes.map(o => {
        if (o.label) {
          o.backUpLabel = o.label;
        }
      });
      newData.data.edges.map(o => {
        if (o.label) {
          o.backUpLabel = o.label;
        }
      });
      return newData;
    },
    async axiosFn(method, url, data = {}, params = {}) {
      let dataResponse = {};
      await axios({
        method: method,
        url: url,
        data: data,
        params: params
      }).then(res => {
        dataResponse = res;
      });
      return dataResponse;
    },
    decimalsToFractional(decimals) {
      const formatDecimals = decimals.toFixed(2);
      let denominator = 100; //初始化分母
      let numerator = formatDecimals * 100; //初始化分子
      let bigger = 0;
      function recursion() {
        bigger = denominator > numerator ? denominator : numerator;
        for (let i = bigger; i > 1; i--) {
          if (Number.isInteger(numerator / i) && Number.isInteger(denominator / i)) {
            numerator = numerator / i;
            denominator = denominator / i;
            recursion();
          }
        }
      }
      recursion();
      // return `${numerator}/${denominator}`
      return denominator / numerator;
    },

    // 获取节点和边的列表
    async getTagEdgeList() {
      const { data } = await this.axiosFn(
        this.methodGet,
        this.getTagEdgeListUrl,
        null,
        this.getTagEdgeListParams
      );
      data.data.data.map(o => {
        const obj = {
          value: o.tableName,
          label: o.tableName
        };
        this.tagEdgeList.push(obj);
      });
    },
    // 查找关系/点数据
    async findPath() {
      $('#nodesBox').css('display', 'none');
      $('#edgesBox').css('display', 'none');
      this.socialArr.nodeSocial = '';
      this.socialArr.edgeSocial = '';
      if (this.tabDataName === 'Relationship') {
        const { data } = await this.axiosFn(
          this.methodPost,
          this.getTwoNodePathUrl,
          this.getTwoNodePathParams
        );
        this.dataObj = this.backUpLabel(data.data);
        await this.loadGraph();
      } else if (this.tabDataName === 'point') {
        const { data } = await this.axiosFn(
          this.methodPost,
          this.searchNodeToGraphDataUrl,
          this.searchNodeToGraphDataParams
        );
        this.dataObj = this.backUpLabel(data.data);
        await this.loadGraph();
      }
    },
    // 获取弹窗中边点数据
    async getCheckData() {
      let more = false;
      this.checkLists = {};
      if (this.edgeNodeFlag) {
        this.getTagEdgeInfoParams.option = 'nodes';
        this.getTagEdgeInfoParams.name = this.dataObj.data.nodeCategories.join(',');
        if (this.dataObj.data.nodeCategories.length > 0) {
          more = true;
        }
      } else {
        this.getTagEdgeInfoParams.option = 'edges';
        this.getTagEdgeInfoParams.name = this.dataObj.data.edgeCategories.join(',');
        if (this.dataObj.data.edgeCategories.length > 0) {
          more = true;
        }
      }
      const { data } = await this.axiosFn(
        this.methodGet,
        this.getTagEdgeInfoUrl,
        null,
        this.getTagEdgeInfoParams
      );
      if (more) {
        for (let key in data.data.data) {
          this.checkList = [];
          data.data.data[key].map(o => {
            const obj = {
              label: o.columnName,
              value: o.columnName
            };
            this.checkList.push(obj);
          });
          this.checkLists[key] = {
            arr: this.checkList,
            model: ''
          };
        }
      } else {
        data.data.data.map(o => {
          const obj = {
            label: o.columnName,
            value: o.columnName
          };
          this.checkList.push(obj);
        });
        this.checkLists = {
          '': {
            arr: this.checkList,
            model: ''
          }
        };
      }
      this.show = true;
    },
    // 显示边
    showEdges() {
      this.edgeNodeFlag = false;
      this.getCheckData();
    },
    // 显示点
    showNodes() {
      this.edgeNodeFlag = true;
      this.getCheckData();
    },
    // 弹窗确定
    submit() {
      if (this.edgeNodeFlag) {
        this.nodeUpdataFn();
      } else {
        this.edgeUpdataFn();
      }
      this.show = false;
    },
    // 弹窗取消
    cancel() {
      this.show = false;
    },
    // 显示边点按钮是否可点击
    btnShowFn() {
      if (this.dataObj.data.nodes.length > 0) {
        this.nodeBtnFlag = false;
      } else {
        this.nodeBtnFlag = true;
      }
      if (this.dataObj.data.edges.length > 0) {
        this.edgeBtnFlag = false;
      } else {
        this.edgeBtnFlag = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.outerBox {
  height: 100%;
  position: relative;
  #graphAreaPickup {
    height: 100%;
    transform-origin: 0 0;
  }
  #btnsDiv {
    position: absolute;
    top: 20px;
    left: 240px;
    el-button {
      margin-right: 10px;
    }
  }
  #nodesBox {
    min-width: 200px;
    padding: 10px;
    background: rgba(230, 217, 202, 0.8);
    box-shadow: rgba(116, 112, 112, 0.555) 1px 1px 10px;
    position: absolute;
    top: 100px;
    left: 10px;
    display: none;
    #nodesBtn {
      position: absolute;
      top: 0;
      right: 5px;
      cursor: pointer;
      color: #a9a9a9;
    }
  }
  #edgesBox {
    min-width: 200px;
    padding: 10px;
    background: rgba(230, 217, 202, 0.8);
    box-shadow: rgba(116, 112, 112, 0.555) 1px 1px 10px;
    position: absolute;
    top: 300px;
    right: 10px;
    display: none;
    #closeBtn {
      position: absolute;
      top: 0;
      right: 5px;
      cursor: pointer;
      color: #a9a9a9;
    }
  }
  #nodePath {
    width: 260px;
    padding: 10px;
    border-width: 2px;
    color: #a9a9a9;
    box-shadow: rgba(116, 112, 112, 0.555) 1px 1px 10px;
    background: #fff;
    position: absolute;
    top: 20px;
    right: 10px;
    .nodePathItem {
      width: 100%;
      margin-bottom: 10px;
    }
  }
  .loading,
  .empty {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loading {
    background: rgba($color: #fff, $alpha: 0.5);
  }
}
</style>
<style lang="scss">
.outerBox {
  .el-checkbox__inner,
  input,
  .el-slider__runway,
  textarea,
  .el-dialog input,
  .el-switch__core,
  .el-dialog .el-slider__runway,
  .el-dialog textarea {
    background: #fff !important;
  }
}
.toolbarPanel {
  display: none !important;
}
.searchPanel {
  width: 200px !important;
  line-height: 26px !important;
  top: 20px !important;
  .searchPanel1 {
    width: 100% !important;
    input {
      width: 96% !important;
    }
  }
  .searchPanel2 {
    display: none !important;
  }
}
</style>
